import { Box, Grid, MenuItem, Typography } from "@mui/material";
import { useContext } from "react";
import { useLocation } from "react-router-dom";
import Label from "../../../components/label";
import CustomDropDown from "../../../components/select";
import TextInput from "../../../components/textInput";
import { AppContext } from "../../../lib/Context";

const routerList = [0, 1, 2, 3];
const COST_TYPE = [
  {
    value: "One Of Cost",
    type: "oneOfCost",
  },
  {
    value: "Monthly",
    type: "monthly",
  },
];

const CordedPhone = () => {
  const location = useLocation();
  const { cordedPhone, setSetCordedPhone } = useContext(AppContext);
  const isDetailPage = location.pathname === "/prospect-details";

  const handleCordedPhoneValueChange = (e) => {
    const newValue = e.target.value;
    setSetCordedPhone((prev) => ({
      ...prev,
      price:
        cordedPhone.costType === "oneOfCost" ? newValue * 20 : newValue * 1.5,
      value: newValue,
    }));
  };

  const handleEditCordedPhoneCharges = (e) => {
    const newValue = parseFloat(e.target.value);

    const forOneOfCost =
      cordedPhone.costType === "oneOfCost" &&
      newValue > cordedPhone.value * 100;

    const forMonthly =
      cordedPhone.costType === "monthly" &&
      newValue > cordedPhone.value * 10000;

    if (newValue < 0 || forOneOfCost || forMonthly) {
      return;
    }

    setSetCordedPhone((prev) => ({
      ...prev,
      price: newValue,
    }));
  };

  const handleCordedCostTypeChange = (e) => {
    const newValue = e.target.value;
    setSetCordedPhone((prev) => ({
      ...prev,
      costType: newValue,
      value: 0,
      price: 0,
    }));
  };

  return (
    <Box mt={2} mb={5}>
      <Typography variant="h6" color={"text.charcoalGrey"}>
        Corded Phones
      </Typography>

      <Grid container mt={0} spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Cost Type"} />
          <CustomDropDown
            variant={"filled"}
            value={cordedPhone.costType}
            onChange={handleCordedCostTypeChange}
            readonly={isDetailPage}
          >
            {COST_TYPE.map((val, ind) => (
              <MenuItem key={ind} value={val.type}>
                {val.value}
              </MenuItem>
            ))}
          </CustomDropDown>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"No. of Corded Phones"} />
          <CustomDropDown
            variant={"filled"}
            value={cordedPhone.value}
            onChange={handleCordedPhoneValueChange}
            readonly={isDetailPage}
          >
            {routerList.map((val, ind) => (
              <MenuItem key={ind} value={val}>
                {val}
              </MenuItem>
            ))}
          </CustomDropDown>
        </Grid>
        {cordedPhone.value > 0 && (
          <Grid item xs={12} sm={6} md={3}>
            <Label title={"Total Cost"} htmlFor={"corded-phone-charges"} />
            <TextInput
              id={"corded-phone-charges"}
              variant={"filled"}
              required
              type={"number"}
              value={cordedPhone.price}
              onChange={handleEditCordedPhoneCharges}
              readonly={isDetailPage}
            />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default CordedPhone;
